import { defineComponent } from '@nuxtjs/composition-api';
import { JOBS_DISCOVERING_TOOLTIP_NAME } from '@/components/common/AnnouncementModal/constants';
import { JOBS_NEW_MENU_TOOLTIP } from '@/constants';

export default defineComponent({
  beforeMount() {
    [JOBS_NEW_MENU_TOOLTIP, JOBS_DISCOVERING_TOOLTIP_NAME].forEach(tooltip => {
      const isNew = !!(this.$auth.loggedIn && !this.$tooltip.isPresent(tooltip));

      if (isNew) {
        this.$tooltip.close(tooltip);
      }
    });
  },
});
